import "./styles.css"

/**
 *
 * @param {{size: number}} param0
 * @returns
 */
export default function SucceedCheckmark({ size }) {
	return (
		<div className="flex flex-center color-fg-green-700" style={{ width: size + "px", height: size + "px" }}>
			<div className="success-animation">
				<svg className="checkmark2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
					<circle className="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
					<path className="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8" />
				</svg>
			</div>
		</div>
	)
}

SucceedCheckmark.defaultProps = {
	size: 200,
}
